import styles from './PolicyPage.module.css';

function TermsPage() {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>서비스 이용약관</h1>
            <div className={styles.content}>
                <div className={styles.section}>
                    <h2>제1조 (목적)</h2>
                    <p>본 약관은 종합센터몰(이하 "회사")이 운영하는 온라인 쇼핑몰에서 제공하는 인터넷 관련 서비스를 이용함에 있어 회사와 이용자의 권리, 의무 및 책임 사항을 규정함을 목적으로 합니다.</p>
                </div>
                <div className={styles.section}>
                    <h2>제2조 (사업자 정보)</h2>
                    <ul>
                        <li>상호: 종합센터몰</li>
                        <li>대표자: 김선진</li>
                        <li>사업자등록번호: 755-32-01468</li>
                        <li>이메일: isunjin74@naver.com</li>
                        <li>주소: 추후 기재 예정</li>
                        <li>전화번호: 추후 기재 예정</li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>제3조 (약관의 효력 및 변경)</h2>
                    <p>① 본 약관은 서비스 화면에 게시하거나 기타 방법으로 이용자에게 공지함으로써 효력이 발생합니다.</p>
                    <p>② 회사는 합리적인 사유가 있을 경우 약관을 변경할 수 있으며, 변경된 약관은 공지사항을 통해 사전 고지합니다.</p>
                    <p>③ 이용자가 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 탈퇴할 수 있습니다.</p>
                </div>
                <div className={styles.section}>
                    <h2>제4조 (서비스 제공 및 변경)</h2>
                    <p>① 회사는 다음과 같은 서비스를 제공합니다.</p>
                    <ul>
                        <li>상품 판매 및 구매 중개</li>
                        <li>주문, 결제, 배송 서비스</li>
                        <li>기타 회사가 정하는 서비스</li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>제5조 (회원 가입 및 탈퇴)</h2>
                    <p>① 이용자는 회사가 정한 양식에 따라 회원 정보를 기입하고 본 약관에 동의함으로써 회원 가입을 신청합니다.</p>
                    <p>② 회원은 언제든지 탈퇴를 요청할 수 있으며, 회사는 즉시 탈퇴를 처리합니다.</p>
                    <p>③ 탈퇴 시 관련 법령에 따라 보존이 필요한 정보를 제외한 모든 개인정보는 삭제됩니다.</p>
                </div>
                <div className={styles.section}>
                    <h2>제6조 (이용자 의무)</h2>
                    <p>① 이용자는 타인의 개인정보를 무단으로 수집, 이용, 제공하여서는 안 됩니다.</p>
                    <p>② 이용자는 회사의 서비스를 이용하여 불법적인 행위를 하여서는 안 됩니다.</p>
                    <p>③ 이용자는 계정 정보를 타인과 공유하거나 양도할 수 없습니다.</p>
                </div>
                <div className={styles.section}>
                    <h2>제7조 (청약철회 및 환불)</h2>
                    <p>① 이용자는 상품 수령 후 7일 이내에 청약철회를 요청할 수 있습니다.</p>
                    <p>② 단, 다음의 경우 청약철회가 제한될 수 있습니다.</p>
                    <ul>
                        <li>이용자의 사용 또는 일부 소비로 상품 가치가 현저히 감소한 경우</li>
                        <li>시간 경과로 재판매가 어려울 정도로 상품 가치가 감소한 경우</li>
                        <li>복제 가능한 상품의 포장을 훼손한 경우</li>
                    </ul>
                    <p>③ 환불은 청약철회 확인 후 3영업일 이내에 처리됩니다.</p>
                </div>
                <div className={styles.section}>
                    <h2>제8조 (면책 조항)</h2>
                    <p>① 회사는 천재지변, 불가항력적 사유로 인한 서비스 중단에 대해 책임을 지지 않습니다.</p>
                    <p>② 회사는 이용자의 귀책 사유로 인한 서비스 이용 장애에 대해 책임을 지지 않습니다.</p>
                </div>
                <div className={styles.section}>
                    <h2>제9조 (분쟁 해결)</h2>
                    <p>① 회사와 이용자 간의 분쟁은 상호 협의를 통해 해결하는 것을 원칙으로 합니다.</p>
                    <p>② 협의가 이루어지지 않을 경우 소비자기본법에 따른 분쟁조정 기관에 조정을 신청할 수 있습니다.</p>
                </div>
                <div className={styles.section}>
                    <p>부칙: 본 약관은 2026년 1월 1일부터 시행합니다.</p>
                </div>
            </div>
        </div>
    );
}

export default TermsPage;